export enum StorageType {
  IndexedDb = 'IndexedDb',
  LocalStorage = 'LocalStorage',
}
